import { gql } from '@apollo/client';

export const DUPLICATE_ACCOUNT = gql`
    mutation duplicateAccount($data: DuplicateAccountInput!) {
        duplicateAccount(data: $data) {
            success
            message
            userId
        }
    }
`;



